var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"radio",staticClass:"radio",class:{active: _vm.boolActive, disabled: _vm.boolDisabled},style:(_vm.objStyle),attrs:{"disabled":_vm.boolDisabled},on:{"click":_vm.click}})
}
var staticRenderFns = []

export { render, staticRenderFns }